import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import 'rsuite/dist/styles/rsuite-default.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Sections from "./sections";

ReactDOM.render(
  <React.StrictMode>
      <Sections/>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
